import React from "react";
import {Box, Typography} from "@mui/material";
import {alpha, useTheme} from "@mui/material/styles";
import {CardBox} from "../Theme/CustomComponent";
import {TrackingHistory} from "./TrackingHistory";
import {TrackingMilestoneStepper} from "./TrackingMilestoneStepper";
import {TrackingShipmentSummary} from "./TrackingShipmentSummary";
import {TrackingTruckIllustration} from "./TrackingTruckIllustration";

const NoTrackingResult = ({truckVariant}) => {
    const theme = useTheme();
    return (
        <CardBox sx={{
            p: 4,
            py: 6,
            borderRadius: `${theme.shape.lg}px`,
            textAlign: "center",
            backgroundColor: "background.paper",
            borderStyle: "dashed",
            borderColor: alpha(theme.palette.neutral[300], 0.8)
        }}>
            <Box sx={{
                mb: 2,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: 70,
                transform: "scale(1.2)"
            }}>
                <TrackingTruckIllustration variant={truckVariant} muted/>
            </Box>
            <Typography variant="subtitle1" color="text.primary" sx={{fontWeight: 600}}>No Tracking Yet</Typography>
            <Typography variant="body2" color="text.secondary" sx={{mt: 0.5, maxWidth: 360, mx: "auto"}}>
                No shipping updates are available for this shipment yet. Please check back later once the carrier scans
                your package.
            </Typography>
        </CardBox>
    );
};

export const TrackingResult = ({result, historyLayout = "timeline", truckVariant = "solid"}) => {
    const theme = useTheme();
    if (result.events.length === 0) {
        return <NoTrackingResult truckVariant={truckVariant}/>;
    }

    return (
        <Box sx={{display: "grid", gap: 2}}>
            <TrackingShipmentSummary result={result}/>
            {result.milestones?.length ? (
                <CardBox sx={{
                    p: {xs: 1.5, sm: 2, md: 2.5},
                    borderRadius: `${theme.shape.lg}px`,
                    boxShadow: theme.shadows[1],
                    borderColor: alpha(theme.palette.neutral[300], 0.8)
                }}>
                    <TrackingMilestoneStepper milestones={result.milestones}/>
                </CardBox>
            ) : null}
            <CardBox sx={{
                p: {xs: 0, sm: 1.75, md: 2},
                borderRadius: `${theme.shape.lg}px`,
                boxShadow: theme.shadows[1],
                borderColor: alpha(theme.palette.neutral[300], 0.8),
                overflow: "hidden"
            }}>
                <Typography variant="subtitle1" sx={{
                    px: {xs: 1.25, sm: 0},
                    pt: {xs: 1.25, sm: 0},
                    mb: 0.75,
                    fontSize: {xs: 14, sm: 16},
                    fontWeight: 600,
                    letterSpacing: "0.06em"
                }}>TRACKING HISTORY</Typography>
                <TrackingHistory events={result.events} layout={historyLayout}/>
            </CardBox>
        </Box>
    );
};
